import { useRef } from 'react';

/**
 * Stable string for dependency arrays when a value is re-created each render
 * but JSON-serializes the same (e.g. GraphQL `targetItems` arrays).
 */
export function useStableSerialized(value: unknown): string {
  const serialized = JSON.stringify(value);
  const ref = useRef(serialized);
  if (ref.current !== serialized) {
    ref.current = serialized;
  }
  return ref.current;
}
